import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";

import {BaseProvider, LightTheme} from 'baseui';
import { Provider as StyletronProvider } from "styletron-react";
import { Client as Styletron } from "styletron-engine-atomic";

import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";

const engine = new Styletron();

ReactDOM.render(
  <StyletronProvider value={engine}>
    <BaseProvider theme={LightTheme}>

  <BrowserRouter>
    <Switch>
      <Route path="/admin" component={Admin} /> {/* Layout */}
      <Route path="/auth" component={Auth} /> {/* Layout */}
      <Redirect from="*" to="/auth/login" />
    </Switch>
  </BrowserRouter>,
  </BaseProvider>

  </StyletronProvider>,
  document.getElementById("root")
);
